import React, { useState } from "react";
import { ClipLoader } from "react-spinners";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import useForm from "../../hooks/useForm";
import LoginInput from "../../components/Form/LoginInput";
import LoginButton from "../../components/Form/LoginButton";
import ButtonSpinner from "../../components/loading/ButtonSpinner";
import facebookIcon from "../../assets/Icons/facebook.svg";
import logo from "../../assets/Sidebar/Dark_logo.png";
import googleIcon from "../../assets/Icons/google.svg";
import appleIcon from "../../assets/Icons/apple.svg";
import blueBg from "../../assets/Login/bluebg.svg";
import loginImage from "../../assets/Login/image1.png";
import LoginImageMobile from "../../assets/Login/mobilebg.svg";
import LoginImageTab from "../../assets/Login/bluebg-tabs.png";
import showToast from "../../utils/toastNotifications";
import { getGoogleAuthUrl } from "../../utils/googleAuth";
import { USER_INPUT_FIELD_TYPES } from "../../constants/userInputFieldNames";
import { errorMessages } from "../../constants/frontendErrorMessages";
import { useThunk } from "../../hooks/useThunk";
import { signin, setUser } from "../../store";

const SignIn = () => {
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);
  const [doSignin, isSigninIn, signinError] = useThunk(signin);
  const navigate = useNavigate();

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
  } = useForm(
    {
      email: "",
      password: "",
      // email: "chamalkaauth@freesourcecodes.com",
      // password: "marasinghe@gmail.com"
    },
    {
      email: true,
      password: true,
    },
    {
      email: USER_INPUT_FIELD_TYPES.EMAIL,
      password: USER_INPUT_FIELD_TYPES.PASSWORD,
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Mark all fields as touched
    setTouched({
      email: true,
      password: true,
    });

    if (validateForm()) {
      const result = await doSignin(formData);
      if (result?.success) {
        const otpSent = result.response?.data.OTP;

        // navigate to OTP page if OTP verification is Needed (OTP skip for thrusted Devices)
        if (otpSent) {
          showToast("success", "OTP Sent To Your Email SuccessFully");
          navigate("/otp", { state: { otpAvailable: true } });
        } else {
          // set token
          localStorage.setItem("token", result.response.data.token);
          dispatch(setUser(result.response.data.userData));
          showToast("success", "Login Sucessfull");
          navigate("/"); // navigate to dashbord
        }
      } else {
        showToast("error", result.error?.message);
      }
    }
  };

  // redirect user to google concent screen
  const handleGoogleSignin = (e) => {
    e.preventDefault();
    const authUrl = getGoogleAuthUrl();
    if (!authUrl) {
      showToast("error", errorMessages.FAILED_GOOGLE_SIGNIN);
      return;
    }
    window.location.href = authUrl;
  };

  return (
    <div className="flex flex-col min-w-[403px] relative w-full  overflow-x-hidden h-screen">
      {/* WatermarkBg*/}
      <div className="lg:hidden absolute right-0 w-[60%]">
        <img
          src={LoginImageMobile}
          alt="background"
          className="sm:hidden w-full"
        />
        <img
          src={LoginImageTab}
          alt="background"
          className="hidden sm:block w-full ml-[40px] pl-8"
        />
      </div>

      <div className="absolute z-0 top-0 right-0 w-full login-br:block">
        <img
          src={blueBg}
          alt="background"
          className="hidden lg:block absolute -right-15 -top-20 lg:right-0 w-full  lg:max-w-[750px] xl:max-w-[750px] 2xl:max-w-[800px] 1920-br:max-w-[850px] 2560-br:max-w-[1400px] transition-all duration-300"
        />
      </div>

      {/* Form Container-left  */}
      <div className="relative z-10 mx-auto mt-20 mb-0 sm:mt-16 pb-10 flex flex-grow items-start sm:items-center justify-center login-br:justify-between w-full 2xl:max-w-[1536px] auth-layout-structure-in-tab-screen-higher-than-880-height">
        <div className="w-full lg:w-[90%] 2xl:w-[60%] flex flex-col justify-center px-10 lg:px-20 ml-0 bg-transparent 1920-br:translate-x-[80px]">
          <div className="flex flex-col sm:flex-row-reverse sm:justify-end">
            <img
              src={logo}
              alt="Main"
              className="sm:ml-[12px] mb-5 sm:mb-0 px-[8px] h-[40px] w-[150px] sm:w-auto"
              />
            <h1 className="text-level-1 font-roboto font-bold leading-[44px] text-primary mb-2 sm:mb-4">
              Sign In
            </h1>
          </div>
          <p className="mb-0 sm:mb-10 font-inter text-[18px] text-gray max-w-[200px] md:max-w-[220px] lg::max-w-[260px] xl:max-w-none">
            Please login to continue to your account.
          </p>

          <form className="w-full sm:max-lg:w-[55%] max-sm:mt-20">
            <div>
              <div className="grid grid-cols-1 md:gap-1 lg:mr-6 xl:mr-36 ">
                <LoginInput
                  className=" w-full 2xl:w-full px-4 "
                  id="email"
                  name="email"
                  label="Email / Phone Number"
                  type="email"
                  value={formData.email}
                  placeholder="Enter your email or phone number"
                  error={touched.email && errors.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                  onBlur={() => handleBlur("email", formData.email)}
                />
                <LoginInput
                  className="relative w-full lg:w-full lg:mr-6 xl:mr-36 2xl:w-full px-4"
                  position=""
                  id="password"
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  placeholder="Enter your password"
                  error={touched.password && errors.password}
                  showPasswordToggle
                  isPasswordVisible={showPassword}
                  togglePasswordVisibility={() =>
                    setShowPassword(!showPassword)
                  }
                  onChange={(e) =>
                    handleInputChange("password", e.target.value)
                  }
                  onBlur={() => handleBlur("password", formData.password)}
                />
              </div>
            </div>

            <div className="flex items-center justify-between mt-3 lg:mr-6 xl:mr-36 ">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="ml-1 accent-blue-shades border-gray-300 rounded"
                />
                <span className="ml-2 font-inter text-[15px] leading-[18.75px] text-gray">
                  Remember me
                </span>
              </label>

              <a
                href="/forgot-password"
                className="font-lato text-[15px] leading-[18.75px] text-blue-shades hover:underline"
              >
                Forgot Your Password?
              </a>
            </div>

            <div className="flex flex-col items-center justify-center mt-14 lg:mr-6 xl:mr-36 ">
              {/* Sign In Button */}
              <LoginButton
                text={
                  isSigninIn ? (
                    <ClipLoader
                      loading={isSigninIn}
                      speedMultiplier={1}
                      size={22}
                      color="#60a5fa"
                    />
                  ) : (
                    "Sign In"
                  )
                }
                type="submit"
                className="w-full py-3 h-[54px]"
                onClick={handleSubmit}
                disabled={isSigninIn}
              />

              {/* Sign Up Link */}
              <p className="mt-3 font-lato text-[15px] text-center leading-[18.75px] text-black/50">
                Don’t have an account?{" "}
                <a href="/signup" className="text-blue-shades hover:underline">
                  Sign Up
                </a>
              </p>

              {/* social logins */}
              <div className="flex mt-8 w-full ">
                <div className="w-full ">
                  <div className="relative">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-medium-gray"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="px-2 font-inter font-medium text-level-3 leading-[24px] text-gray bg-white">
                        or
                      </span>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 h-[54px] gap-4 mt-6">
                    {/* <button
                      className="flex items-center justify-center px-4 py-2 border rounded-md border-medium-gray hover:bg-gray-50"
                      disabled={isSigninIn}
                      type="button"
                    >
                      <img
                        src={facebookIcon}
                        alt="Facebook"
                        className="w-5 h-5"
                      />
                    </button> */}
                    <button
                      className="flex items-center justify-center gap-3 font-inter font-semibold text-[18px] leading-[21.6px] text-gray py-3 rounded-lg hover:bg-[#EFEFEF] transition duration-200 px-4 py-2 border rounded-md border-medium-gray "
                      onClick={handleGoogleSignin}
                      disabled={isSigninIn}
                    >
                      <img src={googleIcon} alt="Google" className="w-5 h-5" />
                      <span>Continue with Google</span>
                    </button>
                    {/* <button
                      className="flex items-center justify-center px-4 py-2 border rounded-md border-medium-gray hover:bg-gray-50"
                      disabled={isSigninIn}
                      type="button"
                    >
                      <img src={appleIcon} alt="Apple" className="w-5 h-5" />
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Right Side: Image */}
        <div className="hidden lg:flex items-center justify-center w-full md:max-w-[480px] lg:max-w-[580px] xl:max-w-[650px] bg-transparent 1920-br:-translate-x-[80px]">
          <img src={loginImage} alt="Sign Up" />
        </div>
      </div>
    </div>
  );
};

export default SignIn;
